export default {
    // user role  获取列表
    getRolePage: "/role/getRolePage",
    //  user role 新增
    getRoleAdd: "/role/saveAccountRole",
    // user role 修改角色
    getUpdateRole: "/role/updateAccountRole",
    // user role 删除角色
    getDelRole: "/role/delAccountRole",
    // 根据人员ID获取角色列表
    getAccountRoleList: "/role/getAccountRoleList",
    //获取所有rolelist
    getRolesList:"/role/getRoleList",
    // 获取当前人员查看合同数据配置
    getAccountContractList:"/account/getAccountContractDetail",
    // 修改角色权限
    updateRoleAdmin: "/role/updateRoleAdmin",
}   